// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// require("jquery") // declared at config/webpack/environment.js
require("bootstrap")
require("admin-lte")
require("summernote")
require("admin-lte/plugins/select2/js/select2.full.min.js")

// Import css from js for webpack to process it correctly
// import '../css/application.css'

$(document).on('turbolinks:load', function() {
  $('.select2').select2();
  $('.select2bs4').select2({
    theme: 'bootstrap4'
  });

  if($('#dropdown-choice-select').length > 0) {
    const Choices = require('choices.js')
    var dropDownSelects = new Choices('#dropdown-choice-select')
  }
});

String.prototype.includes = function (str) {
  var returnValue = false;
  if (this.indexOf(str) !== -1) {
    returnValue = true;
  }
  return returnValue;
}


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
